import request from '@/axios';
import type { LoginType } from './types';
import { useUserStore } from '@/store/modules/user';

//退出登录
export const loginOutApi = (): Promise<IResponse> => {
  const userStore = useUserStore();
  return request.post({
    url: '/employeeAccount/loginOut',
    headers: { resourceId: userStore.getPublicResourceId },
  });
};

// 下面是新接口，上面的打算删除
//登录接口
export const loginApi = (data: LoginType): Promise<IResponse> => {
  return request.post({ url: '/employeeAccount/login', data });
};

//获取资源菜单
export const getMenuResource = (): Promise<IResponse> => {
  const userStore = useUserStore();
  return request.get({
    url: '/employeeAccount/getMenuResource',
    headers: { resourceId: userStore.getPublicResourceId },
  });
};
